import { render, staticRenderFns } from "./weightStatisticList.vue?vue&type=template&id=4d260c63"
import script from "./weightStatisticList.vue?vue&type=script&lang=js"
export * from "./weightStatisticList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports